import React from "react";

import purpleFolder1 from "../../assets/folder-large-purple-1x.png";
import purpleFolder15 from "../../assets/folder-large-purple-1.5x.png";
import purpleFolder2 from "../../assets/folder-large-purple-2x.png";
import purpleFolder3 from "../../assets/folder-large-purple-3x.png";

import blueFolder1 from "../../assets/folder-large-blue-1x.png";
import blueFolder15 from "../../assets/folder-large-blue-1.5x.png";
import blueFolder2 from "../../assets/folder-large-blue-2x.png";
import blueFolder3 from "../../assets/folder-large-blue-3x.png";

import greenFolder1 from "../../assets/folder-large-green-1x.png";
import greenFolder15 from "../../assets/folder-large-green-1.5x.png";
import greenFolder2 from "../../assets/folder-large-green-2x.png";
import greenFolder3 from "../../assets/folder-large-green-3x.png";

interface Props {
  probateTierName?: string;
}

const getFolder = (name?: string): JSX.Element => {
  // case names correspond with database records in probate_types table
  switch (name) {
    case "Light":
      return (
        <img
          srcSet={`${greenFolder15} 1.5x, ${greenFolder2} 2x, ${greenFolder3} 3x`}
          src={greenFolder1}
          alt="Light"
        />
      );
    case "Express":
      return (
        <img
          srcSet={`${blueFolder15} 1.5x, ${blueFolder2} 2x, ${blueFolder3} 3x`}
          src={blueFolder1}
          alt="Express"
        />
      );
    case "Full":
    default:
      return (
        <img
          srcSet={`${purpleFolder15} 1.5x, ${purpleFolder2} 2x, ${purpleFolder3} 3x`}
          src={purpleFolder1}
          alt="Full"
        />
      );
  }
};

export const ProbateFolder = ({ probateTierName }: Props): JSX.Element => {
  return getFolder(probateTierName);
};
